module.exports = __webpack_public_path__ + "static/media/01en.ccd00895.jpg";